var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderAddressEdit',{attrs:{"loading":_vm.loading,"order":_vm.orderData,"field":"invoiceAddress"},on:{"reload":function($event){return _vm.$emit('reload')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }